module.exports = __webpack_public_path__ + "static/media/recipe_category_3.cef5db1f.png";